import { css } from '@emotion/css';

import { AlignItems, Display, Spacing } from '../../../styles';

export const contentWrapper = css`
  background: #ffffff;
  min-height: 745px !important;
`;

export const withMaxWidth = css`
  max-width: 75rem;
  width: 100%;
  ${Spacing.px8}
`;

export const layoutWrapper = css`
  background: #ffffff;
  ${Display.flex}
  ${AlignItems.center}
`;
